import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import PaymentRow from './PaymentRow';
import styles from './PaymentPackages.css';


export default class PaymentPackages extends PureComponent {
  static propTypes = {
    changeActivePackage: PropTypes.func.isRequired,
    isGoldUser: PropTypes.bool.isRequired,
    packages: PropTypes.array.isRequired,
    selectedMethod: PropTypes.object.isRequired,
    selectedPackage: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    allActiveCampaigns: PropTypes.object,
    selectedCryptoCurrency: PropTypes.object,
  };

  static defaultProps = {
    allActiveCampaigns: undefined,
    selectedCryptoCurrency: undefined,
  };

  render() {
    const {
      allActiveCampaigns,
      changeActivePackage,
      isGoldUser,
      packages,
      selectedCryptoCurrency,
      selectedMethod,
      selectedPackage,
      user,
    } = this.props;

    return (
      <div className={styles.paymentPackages}>
        {packages.map((pack, ind) => (
          <PaymentRow
            key={pack.id}
            allActiveCampaigns={allActiveCampaigns}
            index={ind}
            isActive={selectedPackage.id === pack.id}
            isGoldUser={isGoldUser}
            pack={pack}
            selectedCryptoCurrency={selectedCryptoCurrency}
            selectedMethod={selectedMethod}
            setActive={changeActivePackage}
            user={user}
          />
        ))}
      </div>
    );
  }
}
